// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AzureAksClusterTier } from './AzureAksClusterTier';
import {
  AzureAksClusterTierFromJSON,
  AzureAksClusterTierFromJSONTyped,
  AzureAksClusterTierToJSON,
  AzureAksClusterTierToJSONTyped,
} from './AzureAksClusterTier';
import type { AzureAksNodePool } from './AzureAksNodePool';
import {
  AzureAksNodePoolFromJSON,
  AzureAksNodePoolFromJSONTyped,
  AzureAksNodePoolToJSON,
  AzureAksNodePoolToJSONTyped,
} from './AzureAksNodePool';

/**
 *
 * @export
 * @interface AzureAks
 */
export interface AzureAks {
  /**
   *
   * @type {string}
   * @memberof AzureAks
   */
  masterVersion?: string;
  /**
   *
   * @type {Array<AzureAksNodePool>}
   * @memberof AzureAks
   */
  nodePools?: Array<AzureAksNodePool>;
  /**
   *
   * @type {AzureAksClusterTier}
   * @memberof AzureAks
   */
  tier?: AzureAksClusterTier;
  /**
   *
   * @type {Array<string>}
   * @memberof AzureAks
   */
  zones?: Array<string>;
}

/**
 * Check if a given object implements the AzureAks interface.
 */
export function instanceOfAzureAks(value: object): value is AzureAks {
  return true;
}

export function AzureAksFromJSON(json: any): AzureAks {
  return AzureAksFromJSONTyped(json, false);
}

export function AzureAksFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AzureAks {
  if (json == null) {
    return json;
  }
  return {
    masterVersion:
      json['master_version'] == null ? undefined : json['master_version'],
    nodePools:
      json['node_pools'] == null
        ? undefined
        : (json['node_pools'] as Array<any>).map(AzureAksNodePoolFromJSON),
    tier:
      json['tier'] == null
        ? undefined
        : AzureAksClusterTierFromJSON(json['tier']),
    zones: json['zones'] == null ? undefined : json['zones'],
  };
}

export function AzureAksToJSON(json: any): AzureAks {
  return AzureAksToJSONTyped(json, false);
}

export function AzureAksToJSONTyped(
  value?: AzureAks | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    master_version: value['masterVersion'],
    node_pools:
      value['nodePools'] == null
        ? undefined
        : (value['nodePools'] as Array<any>).map(AzureAksNodePoolToJSON),
    tier: AzureAksClusterTierToJSON(value['tier']),
    zones: value['zones'],
  };
}
